module.exports = __webpack_public_path__ + "src/img/artist/artistpage4.svg?11eeac32375f6177969916322d7a655e";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/artistpage4.svg
// module id = 122
// module chunks = 0